import { render, staticRenderFns } from "./smartIdDataInfo.vue?vue&type=template&id=790e468b&"
import script from "./smartIdDataInfo.vue?vue&type=script&lang=js&"
export * from "./smartIdDataInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports